import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useFertilizers } from "stores";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import { useActionModalGetContext } from "context/ActionModalProvider";
import Loader from "../../../Loader/Loader";
import NoContentFound from "../../../NoContentFound/NoContentFound";
import FertilizeSuggestion from "./FertilizeSuggestion";
import FertilizePerformed from "./FertilizePerformed";
import checkIfPerformedWithSuggested from "components/action-modal/utils/checkIfPerformedWithSuggested";

const FertilizeDetails = ({ viewMode, status, isNewVersion }) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();
  const isPerformedWithSuggested = checkIfPerformedWithSuggested(values);

  const { fieldInfo } = useActionModalGetContext();
  const cropId = fieldInfo.varietyRead?.cropId;
  const { fertilizers, fetchState } = useFertilizers({ cropId });

  if (fetchState.isLoading) {
    return <Loader />;
  }
  if (fetchState.isError) {
    return (
      <NoContentFound
        sx={{ "& .text": { fontSize: "16px" } }}
        text={t("ActionModal.Error.FetchingData")}
      />
    );
  }
  if (
    viewMode === ACTION_VIEW_MODE.view ||
    viewMode === ACTION_VIEW_MODE.edit
  ) {
    if (status !== ACTION_STATUS.performed) {
      return (
        <FertilizeSuggestion
          viewMode={viewMode}
          isFullWidth
          fertilizers={fertilizers}
        />
      );
    } else if (isPerformedWithSuggested) {
      return (
        <div className="action-details-both-box-wrapper">
          <FertilizeSuggestion
            viewMode={ACTION_VIEW_MODE.view}
            fertilizers={fertilizers}
            isProposedValue
          />
          <FertilizePerformed viewMode={viewMode} fertilizers={fertilizers} />
        </div>
      );
    } else {
      return (
        <FertilizePerformed
          viewMode={viewMode}
          isFullWidth
          fertilizers={fertilizers}
        />
      );
    }
  } else if (viewMode === ACTION_VIEW_MODE.new) {
    if (status !== ACTION_STATUS.performed) {
      return (
        <FertilizeSuggestion
          viewMode={viewMode}
          isFullWidth
          fertilizers={fertilizers}
          isNewVersion={isNewVersion}
        />
      );
    } else {
      return (
        <FertilizePerformed
          viewMode={viewMode}
          isFullWidth
          fertilizers={fertilizers}
          isNewVersion={isNewVersion}
        />
      );
    }
  } else {
    return <></>;
  }
};

export default FertilizeDetails;
